import type { CommonsStats, Config, Session } from "./types";

export const API_BASE = (import.meta.env.VITE_API_BASE as string | undefined)?.replace(/\/$/, "") || window.location.origin;

export function wsUrl(session: string, depth: number): string {
  const url = new URL(`${API_BASE}/api/ws`);
  url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
  url.searchParams.set("session", session);
  url.searchParams.set("depth", String(depth));
  return url.toString();
}

async function fetchJson<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers: { "content-type": "application/json", ...(init?.headers ?? {}) }
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `${res.status} ${res.statusText}`);
  }
  return res.json() as Promise<T>;
}

export function getConfig(): Promise<Config> {
  return fetchJson<Config>("/api/config");
}

export function createSession(deviceKey: string, turnstileToken: string, consentVersion: string): Promise<Session> {
  return fetchJson<Session>("/api/session", {
    method: "POST",
    body: JSON.stringify({ deviceKey, turnstileToken, consentVersion })
  });
}

export function getStats(): Promise<CommonsStats> {
  return fetchJson<CommonsStats>("/api/stats");
}

export function submitReflection(sessionToken: string, roomId: string | undefined, text: string): Promise<{ ok: boolean; embedded: boolean; nearest: Array<{ text: string; score: number; createdAt: string }> }> {
  return fetchJson("/api/reflection", {
    method: "POST",
    headers: { Authorization: `Bearer ${sessionToken}` },
    body: JSON.stringify({ roomId, text })
  });
}
